import { getSelectedHotelId, isHotelSelected } from '../../modules/resourceOrder/selectors';
import { getSelectedEnterpriseDefaultLanguageName } from '../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ApplicationState, DistributorThunkAction } from '../../types';

const prefix = (eventName: string) => `${'distributor'}${eventName}`;

const getBaseEventData = (event: string, data = {}, state: ApplicationState) => ({
    ...(isHotelSelected(state)
        ? {
              hotelName: getSelectedEnterpriseDefaultLanguageName(state, {}),
              hotelId: getSelectedHotelId(state),
          }
        : {}),
    event: prefix(event),
    eventName: event,
    ...data,
});

export const trackEvent =
    (eventName: string, data?: {}): DistributorThunkAction =>
    (_dispatch, getState, { loggerService, appClockService, gainsightService }) => {
        gainsightService.trackEvent(eventName, data);
        loggerService.log('event', 'gtmEvent', {
            timestamp: appClockService.getAppNowUtc().value,
            ...getBaseEventData(eventName, data, getState()),
        });
    };
